/**
 * @module ol/interaction/Property
 */

/**
 * @enum {string}
 */
export default {
  ACTIVE: 'active'
};

//# sourceMappingURL=Property.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/ol/interaction/Property.js
// module id = ../../../../ol/interaction/Property.js
// module chunks = 3